const BASIC_HEADER_TITLE_FONT_SIZE_SMALL = 'B12';
const BASIC_HEADER_KEY_INFO_ITEM_FONT_SIZE_SMALL = 'B12';
const PRICE_SMALL_FONT_SIZE = 'B12';

export {
  BASIC_HEADER_TITLE_FONT_SIZE_SMALL,
  BASIC_HEADER_KEY_INFO_ITEM_FONT_SIZE_SMALL,
  PRICE_SMALL_FONT_SIZE,
};
